module.exports = __webpack_public_path__ + "img/third-floor.fadbb0e1.jpg";